module.exports = __webpack_public_path__ + "img/common-tools-feedback.f0955151.svg";